
export const IAttributes = {
    Actor: "custom:Actor",
    PixelStreaming : "custom:Pixelstreaming",
    Company : "custom:Company",
    Tenants : "custom:Tenants",
    BackgroundImage : "custom:BackgroundImage",
    GivenName: "given_name",
    FamilyName: "family_name",
    Email: "email",
    Sub : "sub",
    Options : "custom:Options"
}

export const getAttr = (attrarray , attr) => {
    let value = null;
    attrarray.forEach(element => {
        if (element.Name === attr) value = element.Value;
    });
    return value;
 }
